<template>
  <WrapperCell
      code="benefit_bonus"
      label="Бонусы"
      :icon="ICONS.bonus"
      @open="onClick"
      :active="active"
      :model-value="bonuses"
      :mode="mode"
  >
    <template #default>
      <span class="s-font-3xs">есть {{ bonusesAvailable }}</span>
    </template>
  </WrapperCell>
</template>

<script lang="ts" setup>

import BenefitDialog from "@/components/Shop/VOrder/ui/Dialog/Benefit.vue";
import {VOrderSectionProps, vorderSectionPropsDefault} from "./util";
import {useStackRouter} from "@/packages/stack-router/hooks/useStackRouter";
import {ICONS} from "@/assets/icons";
import WrapperCell from "@/components/Shop/VOrder/ui/Section/Wrapper/WrapperCell.vue";
import {useVorderState} from "@/modules/shop/store/vorder-state";
import {useLoalityStore} from "@/modules/shop/store/loyalty";
import {storeToRefs} from "pinia";
import {useVorderTotalStore} from "@/modules/shop/store/vorder-total";

const vorderState = useVorderState()
const loaltyStore = useLoalityStore()
const totalStore = useVorderTotalStore()
const {bonusesAvailable, bonuses} = storeToRefs(loaltyStore)
const {bonusesMax} = storeToRefs(totalStore)

const props = withDefaults(defineProps<VOrderSectionProps>(), {
  ...vorderSectionPropsDefault,
})


</script>

<style scoped>

</style>
